module.exports = __webpack_public_path__ + "img/group-three.ff51cac7.png";